import React from 'react';
import {getTranslated} from "~/Components/ContentTranslate/Translate";
import {connect} from "react-redux";
import TextTranslate from '../../Components/TextTranslate/TextTranslate';
import BooleanToString from '../../helpers/BooleanToString';

const SpecialRequirements = ({guest, index, currentLanguage, ...props}) => {

    let dietaries = guest.dietaries.map((d) => getTranslated(d, 'name', currentLanguage));

    return (
        <div className="guest-personal-details">
            <div className="row">
                <div className="col-lg-4 col-12">
                    <label><TextTranslate name="form-dietary" fallback="Dietary"/></label>
                </div>
                <div className="col-lg-8 col-12">
                    <p>{dietaries.join('; ')}</p>
                </div>
            </div>

            <hr/>
            <div className="row">
                <div className="col-lg-4 col-12">
                    <label>
                        <TextTranslate name="regpreview-specific-medical-req" fallback="Specific medical requirements" textOnly/>
                    </label>
                </div>
                <div className="col-lg-8 col-12">
                    <p>
                        <BooleanToString condition={guest.requirement.medical_needs} />
                    </p>
                </div>
            </div>
            {guest.requirement.medical_needs && (
                <>
                <hr/>
                <div className="row">
                    <div className="col-lg-4 col-12">
                        <label><TextTranslate name="form-additional-comments" fallback="Additional comments"/></label>
                    </div>
                    <div className="col-lg-8 col-12">
                        <p>{guest.requirement.medical_comments || '-'}</p>
                    </div>
                </div>
                </>
            )}
            <hr/>
            <div className="row">
                <div className="col-lg-4 col-12">
                    <label>
                        <TextTranslate name="regpreview-wheelchair-question" fallback="Wheelchair?" textOnly/>
                    </label>
                </div>
                <div className="col-lg-8 col-12">
                    <p>
                        <BooleanToString condition={guest.requirement.wheelchair} />
                    </p>
                </div>
            </div>
            <hr/>
            <div className="row">
                <div className="col-lg-4 col-12">
                    <label><TextTranslate name="form-additional-comments" fallback="Additional comments"/></label>
                </div>
                <div className="col-lg-8 col-12">
                    <p>{guest.requirement.mobility_comments || '-'}</p>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations?.currentLanguage,
});

export default connect(mapStateToProps)(SpecialRequirements);
